export default function CTASection() {
  return (
    <section className="w-full bg-gradient-to-b from-[#F0F7FF] to-white py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mx-auto text-center">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20document%20scanner%20mobile%20app%20banner%20illustration%20showing%20smartphone%20scanning%20a%20paper%20document%20with%20clean%20minimal%20flat%20design%20style%20light%20background%20soft%20blue%20and%20green%20accents%20professional%20product%20marketing%20illustration&width=1200&height=500&seq=4&orientation=landscape"
            alt="ScanDoc app banner"
            className="w-full rounded-2xl shadow-md object-cover mb-10 md:mb-14"
          />
          <p className="text-xl md:text-2xl text-gray-800 leading-relaxed">
            <span className="font-bold">Scan</span>,{" "}
            <span className="font-light italic">edit</span>, and{" "}
            <span className="font-bold">share</span> your documents{" "}
            <span className="font-light italic">instantly</span> with
            professional-grade tools right from your phone.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.forcekeys.scandoc.app"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#1A1A1A] hover:bg-[#333] text-white text-sm font-semibold px-8 py-4 rounded-full transition-colors mt-10 whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-google-play-fill text-base"></i>
            </span>
            Download Now
          </a>
        </div>
      </div>
    </section>
  );
}